var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveFullMarket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    rx: 39,
    fill: "#EFF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.8481 54.4564V59.4887H44.0322V55.8942L46.9078 53.0186L50.5024 56.6131L52.6591 54.4564L54.8158 56.6131L58.4103 53.0186L59.8481 54.4564Z",
    fill: "#2563EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8481 43.6709V54.4545L58.4103 53.0166L54.8158 56.6112L52.6591 54.4545L50.5024 56.6112L46.9078 53.0166L44.0322 55.8923V52.2977L48.3456 47.9843L51.9402 51.5788L59.8481 43.6709Z",
    fill: "#60A5FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6267 53.7375V59.4887H44.0322V55.8942L46.9078 53.0186L47.6267 53.7375Z",
    fill: "#059669"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1429 49.7826L47.6267 52.2988V53.7366L46.9078 53.0177L44.0322 55.8933V52.2988L48.3456 47.9854L50.1429 49.7826Z",
    fill: "#059669"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.848 43.6709V47.2654L55.5346 51.5788L53.7373 49.7816L59.848 43.6709Z",
    fill: "#059669"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7783 45.1104H29.6539V56.6128H26.7783V45.1104Z",
    fill: "#2563EB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0273 49.4248H23.903V56.6138H21.0273V49.4248Z",
    fill: "#93C5FD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5298 42.2354H35.4054V56.6134H32.5298V42.2354Z",
    fill: "#60A5FA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7783 45.1104H28.2161V56.6128H26.7783V45.1104Z",
    fill: "#059669"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0273 49.4248H22.4652V56.6138H21.0273V49.4248Z",
    fill: "#1D4ED8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5298 42.2354H33.9676V56.6134H32.5298V42.2354Z",
    fill: "#059669"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9692 22.136C39.9278 23.6281 40.4375 25.3642 40.4375 27.1377H31.0918V17.792C32.6637 17.7976 34.209 18.1983 35.5856 18.9574C36.9621 19.7165 38.1256 20.8095 38.9692 22.136Z",
    fill: "#60A5FA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4417 36.9572C33.5685 37.9362 32.4987 38.7201 31.3021 39.2577C30.1055 39.7953 28.809 40.0746 27.4971 40.0772C22.3704 40.0772 18.1514 35.8582 18.1514 30.7315C18.1514 25.6048 22.3704 21.3857 27.4971 21.3857V30.7315H36.8429C36.8402 33.0323 35.9847 35.2504 34.4417 36.9572Z",
    fill: "#93C5FD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6863 18.5199V27.1377H31.0918V17.792C32.3267 17.7911 33.5491 18.0386 34.6863 18.5199Z",
    fill: "#059669"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2962 39.9011C28.7037 40.0186 28.1011 40.0776 27.4971 40.0772C22.3704 40.0772 18.1514 35.8582 18.1514 30.7315C18.1514 25.6048 22.3704 21.3857 27.4971 21.3857V22.1136C24.1326 23.5335 21.7459 26.8755 21.7459 30.7315C21.7459 35.2444 25.016 39.0546 29.2962 39.9011Z",
    fill: "#1D4ED8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3512 24.77L36.3345 23.7533L39.929 20.1588C39.9957 20.092 40.075 20.0391 40.1622 20.003C40.2495 19.9668 40.3429 19.9482 40.4373 19.9482H46.1886V21.386H40.7351L37.3512 24.77Z",
    fill: "#2563EB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1887 38.6392H35.4051C35.3107 38.6392 35.2172 38.6206 35.13 38.5844C35.0428 38.5483 34.9635 38.4954 34.8968 38.4286L31.3022 34.8341L32.319 33.8174L35.7028 37.2014H46.1887V38.6392Z",
    fill: "#2563EB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9997 60.2081H18.1515C17.9609 60.2081 17.778 60.1324 17.6432 59.9975C17.5084 59.8627 17.4326 59.6799 17.4326 59.4892V41.5166H18.8704V58.7703H38.9997V60.2081Z",
    fill: "#2563EB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6265 19.9482H53.3777V21.386H47.6265V19.9482Z",
    fill: "#60A5FA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6265 22.8252H53.3777V24.263H47.6265V22.8252Z",
    fill: "#60A5FA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6265 25.7002H53.3777V27.138H47.6265V25.7002Z",
    fill: "#60A5FA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8154 22.8252H60.5667V24.263H54.8154V22.8252Z",
    fill: "#60A5FA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8159 25.7002H60.5671V27.138H54.8159V25.7002Z",
    fill: "#60A5FA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6265 37.2021H53.3777V38.64H47.6265V37.2021Z",
    fill: "#93C5FD"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8154 37.2021H60.5667V38.64H54.8154V37.2021Z",
    fill: "#93C5FD"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6265 34.3271H53.3777V35.765H47.6265V34.3271Z",
    fill: "#93C5FD"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8154 34.3271H60.5667V35.765H54.8154V34.3271Z",
    fill: "#93C5FD"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6265 31.4521H53.3777V32.89H47.6265V31.4521Z",
    fill: "#93C5FD"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8154 31.4521H60.5667V32.89H54.8154V31.4521Z",
    fill: "#93C5FD"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5668 60.2081H41.1564C40.9657 60.2081 40.7829 60.1324 40.6481 59.9975C40.5132 59.8627 40.4375 59.6799 40.4375 59.4892V41.5166H41.8753V58.7703H60.5668V60.2081Z",
    fill: "#2563EB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveFullMarket);
export default __webpack_public_path__ + "static/media/Active-FullMarket.27d9f6f830ce017cb13bcf967bab4570.svg";
export { ForwardRef as ReactComponent };